import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: [],
};

const managedResourceTypes = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_MANAGED_RESOURCE_TYPES_IN_APPLICATION):
      return { ...state, loading: false };
    case successAction(types.GET_MANAGED_RESOURCE_TYPES_IN_APPLICATION):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.GET_MANAGED_RESOURCE_TYPES_IN_APPLICATION):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default managedResourceTypes;
